export const T = {
  en_GB: { clearSearch: "Clear search" },
  nb_NO: { clearSearch: "Tøm søk" },
} as const;
